import { render, staticRenderFns } from "./OrderSystem.vue?vue&type=template&id=1d7ff7e4&scoped=true&"
import script from "./OrderSystem.vue?vue&type=script&lang=js&"
export * from "./OrderSystem.vue?vue&type=script&lang=js&"
import style0 from "./OrderSystem.vue?vue&type=style&index=0&id=1d7ff7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ff7e4",
  null
  
)

export default component.exports